/**
 * Parse CSV text into headers and data rows (RFC 4180–style quoted fields).
 * @param {string} text
 * @returns {{ headers: string[], rows: string[][] }}
 */
export function parseCSV(text) {
  const raw = typeof text === "string" ? text.replace(/^\uFEFF/, "") : "";
  if (!raw.trim()) {
    return { headers: [], rows: [] };
  }

  const rows = [];
  let row = [];
  let cur = "";
  let inQuotes = false;

  const pushCell = () => {
    row.push(cur);
    cur = "";
  };

  const pushRow = () => {
    rows.push(row);
    row = [];
  };

  for (let i = 0; i < raw.length; i++) {
    const c = raw[i];
    if (inQuotes) {
      if (c === '"') {
        if (raw[i + 1] === '"') {
          cur += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        cur += c;
      }
    } else if (c === '"') {
      inQuotes = true;
    } else if (c === ",") {
      pushCell();
    } else if (c === "\n") {
      pushCell();
      pushRow();
    } else if (c === "\r") {
      /* ignore; \r\n handled by \n */
    } else {
      cur += c;
    }
  }
  pushCell();
  if (row.length > 1 || (row.length === 1 && row[0] !== "")) {
    pushRow();
  }

  if (rows.length === 0) {
    return { headers: [], rows: [] };
  }

  const headers = rows[0].map((h) => String(h).trim());
  const dataRows = rows
    .slice(1)
    .filter((r) => r.some((cell) => String(cell).trim() !== ""));
  return { headers, rows: dataRows };
}
